/** Persistent wrong-network banner with a one-tap switch (wagmi adds Base Sepolia to the wallet if needed). */
import { useState } from 'react';
import { useAccount, useSwitchChain } from 'wagmi';
import { toast } from 'react-hot-toast';
import { ACTIVE_CHAIN } from '../wallet/config';
import { CHAIN } from '../config/chain';
import { BASE_SEPOLIA_GAS_FAUCET } from './YourKeysPanel';
import { describeWalletError, WalletStepError } from '../utils/walletErrors';

export default function NetworkBanner() {
  const { address, chainId } = useAccount();
  const { switchChainAsync, isPending } = useSwitchChain();
  const [err, setErr] = useState<string | null>(null);
  if (!address || chainId === ACTIVE_CHAIN.id) return null;
  const doSwitch = async () => {
    setErr(null);
    try { await switchChainAsync({ chainId: ACTIVE_CHAIN.id }); }
    catch (e) { const m = describeWalletError(new WalletStepError('switch', e), CHAIN.chainName || 'Base Sepolia'); setErr(m); toast.error(m); }
  };
  return (
    <div className="nt3d-netbanner" role="alert">
      <span>⚠ Wrong network. This game runs on <b>{CHAIN.chainName}</b> (testnet). Buying and claiming are off until you switch.</span>
      <button type="button" className="holo-btn sm" disabled={isPending} onClick={() => void doSwitch()}>{isPending ? 'Switching…' : `Switch to ${CHAIN.chainName}`}</button>
      {CHAIN.isTestnet && <a href={BASE_SEPOLIA_GAS_FAUCET} target="_blank" rel="noreferrer">Need test ETH for gas?</a>}
      {err && <small className="mono">{err}</small>}
    </div>
  );
}
